import { TileText, TileTitle } from '@design-system';

import { ImageDetailStoryblok } from '../../types/generated-storyblok';
import { Image } from './Image';

export const ImageDetail = ({ blok }: { blok: ImageDetailStoryblok }) => {
  return (
    <div className="flex w-full flex-col gap-5">
      <Image
        alt={blok.image?.alt || blok.title || ''}
        className="overflow-hidden rounded-sm"
        size={{
          sm: { span: 12, ratio: blok.ratio },
          md: { span: 12, ratio: blok.ratio },
          lg: { span: 12, ratio: blok.ratio },
        }}
        src={blok.image.filename}
      />
      <div className="flex w-full flex-col gap-5">
        {blok.title && (
          <TileTitle as="h3" className="text-md">
            {blok.title}
          </TileTitle>
        )}
        {blok.description && (
          <TileText
            as="p"
            className="whitespace-pre-line text-sm-mobile md:text-sm"
          >
            {blok.description}
          </TileText>
        )}
      </div>
    </div>
  );
};
